export default "__VITE_ASSET__BgPS4Tuq__"